import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { Box, CircularProgress, Typography, withStyles } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import GetAppIcon from '@material-ui/icons/GetApp'
import { ThemeButton } from '../../../ui'
import { requests } from '../../../core/ajax/requests'
import { feedback } from '../../../core/feedback'
import { usersExportDownloadStyles } from './users-export-download.styles'

export const UsersExportDownloadComponent = withStyles(usersExportDownloadStyles)(({ classes }) => {
  const { formatMessage } = useIntl()
  const { exportId } = useParams()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const handleDownload = () => {
    setLoading(true)
    setError(false)
    requests
      .usersExportDownload(exportId)
      .then((response) => {
        const { download_url: downloadUrl, filename } = response?.data || {}
        if (downloadUrl) {
          const link = document.createElement('a')
          link.href = downloadUrl
          if (filename) link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.remove()
        }
      })
      .catch(({ response }) => {
        setError(true)
        if (response?.status === 410 || response?.status === 404 || response?.status === 409) {
          feedback('error', formatMessage({ id: 'pages.users-export-download.error.expired' }))
        } else {
          feedback('error', formatMessage({ id: 'calls.default.error.description' }))
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Box className={classes.root}>
      {!error ? (
        <>
          <Box className={classes.titleContainer}>
            <Typography variant="h4" color="primary">
              {formatMessage({ id: 'pages.users-export-download.title' })}
            </Typography>
            <CheckCircleIcon className={classes.statusIcon} />
          </Box>
          <Typography variant="h5" paragraph>
            {formatMessage({ id: 'pages.users-export-download.subtitle' })}
          </Typography>
        </>
      ) : (
        <>
          <Box className={classes.titleContainer}>
            <Typography variant="h4" color="error">
              {formatMessage({ id: 'pages.users-export-download.error.title' })}
            </Typography>
            <ErrorIcon className={classes.errorIcon} />
          </Box>
          <Typography variant="h5" paragraph>
            {formatMessage({ id: 'pages.users-export-download.error.subtitle' })}
          </Typography>
        </>
      )}
      <ThemeButton
        style={{ width: '16em' }}
        color="primary"
        onClick={handleDownload}
        disabled={loading}
        endIcon={loading ? <CircularProgress size={20} /> : <GetAppIcon />}
      >
        {formatMessage({ id: 'pages.users-export-download.btn' })}
      </ThemeButton>
    </Box>
  )
})
